import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../state/auth/AuthContext';
import { getDashboardPath, isAuthRoute } from '../utils/navigation';

/**
 * Hook to prevent navigation to auth pages when user is authenticated
 * This helps prevent issues with back button navigation
 */
export function useNavigationGuard() {
  const { isAuthenticated, user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't do anything while loading or if not authenticated
    if (loading || !isAuthenticated || !user) return;

    const currentPath = location.pathname;

    // If user is authenticated and trying to access auth routes, redirect to appropriate dashboard
    if (isAuthRoute(currentPath)) {
      const redirectPath = getDashboardPath(user.role);
      
      // Clear history and prevent back navigation
      window.history.replaceState(null, '', redirectPath);
      
      // Use replace to prevent going back to auth page
      navigate(redirectPath, { replace: true });
    }
  }, [isAuthenticated, user, location.pathname, navigate, loading]);
}